import React from "react";
import App from "./App/App";
import HttpsRedirect from "react-https-redirect";
import * as serviceWorker from "./serviceWorker";
import { createRoot } from "react-dom/client";

// ROUTER
import { HashRouter } from "react-router-dom";

// THEME
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import muiTheme from "./theme/muiTheme";

// REDUX
import { Provider } from "react-redux";
import { store } from "./_helpers";

import ReactModal from "react-modal";

ReactModal.setAppElement("#root");

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <Provider store={store}>
    {process.env.NODE_ENV.includes("development") ? (
      <HashRouter>
        <StyledEngineProvider injectFirst>
          <MuiThemeProvider theme={muiTheme}>
            <App />
          </MuiThemeProvider>
        </StyledEngineProvider>
      </HashRouter>
    ) : (
      <HttpsRedirect>
        <HashRouter>
          <StyledEngineProvider injectFirst>
            <MuiThemeProvider theme={muiTheme}>
              <App />
            </MuiThemeProvider>
          </StyledEngineProvider>
        </HashRouter>
      </HttpsRedirect>
    )}
  </Provider>
);

// ReactDOM.render(
//   <Provider store={store}>
//     {process.env.NODE_ENV.includes("development") ? (
//       <HashRouter>
//         <MuiThemeProvider theme={muiTheme}>
//           <App />
//         </MuiThemeProvider>
//       </HashRouter>
//     ) : (
//       <HttpsRedirect>
//         <HashRouter>
//           <MuiThemeProvider theme={muiTheme}>
//             <App />
//           </MuiThemeProvider>
//         </HashRouter>
//       </HttpsRedirect>
//     )}
//   </Provider>,
//   document.getElementById("root")
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
